import { useState, type PropsWithChildren } from 'react';

import type { Meta, StoryFn } from '@storybook/react';
import type { RteEditorProps } from './RteEditor';

import { RteEditor } from './RteEditor';
import { MOCK_RTE_CONTENT } from './mockRteContent';

import { Container } from 'storyComponents/Container';

const codeString = `<RteEditor
          initialValue=""
          currentLanguage="NL"
          label=""
          info=""
          placeholder=""
          notValidatedText=""
          onChange={handleChange}
        />`;

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Organisms/RteEditor',
  component: RteEditor,
  parameters: {
    inspectComponent: RteEditor,
    codeString: codeString,
  },
} as Meta<PropsWithChildren<RteEditorProps>>;

const Template: StoryFn<PropsWithChildren<RteEditorProps>> = (args) => {
  const [result, setResult] = useState<string>(args.initialValue || '');

  return (
    <>
      <Container size="large-full-height">
        <RteEditor {...args} onChange={(evt) => setResult(evt)} />
      </Container>
      <br />
      <br />

      <p style={{ margin: '0', marginTop: '2rem' }}>HTML Output:</p>
      <div
        style={{
          marginTop: '0rem',
          padding: '1rem',
          backgroundColor: '#F9F9F9',
          borderRadius: '0.25rem',
          color: '#666',
        }}
      >
        {result}
      </div>
    </>
  );
};

export const RteEditorExample = Template.bind({});

RteEditorExample.args = {
  placeholder: 'Voeg hier tekst in...',
  currentLanguage: 'NL',
  label: 'Studiemateriaal',
  info: "Studiemateriaal is essentieel voor succesvol leren. Het omvat boeken, artikelen, video's en oefeningen die studenten helpen hun kennis te vergroten, vaardigheden te ontwikkelen en hun studieprestaties te verbeteren.",
  required: true,
  maxWords: 100,
  initialValue: MOCK_RTE_CONTENT,
};

export const MultipleRteEditors = () => {
  const [result01, setResult01] = useState<string>('Editor 1 <ul><li>aap</li> <li>noot</li> <li>mies</li></ul>');
  const [result02, setResult02] = useState<string>('<p>Editor 2</p>');

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        gap: '1rem',
        width: '100%',
        padding: '1rem',
        backgroundColor: '#FFF',
      }}
    >
      <div style={{ flex: '1' }}>
        <RteEditor
          initialValue={result01}
          label="Editor 1"
          info="Uitleg over editor 1"
          placeholder="Voeg hier tekst in..."
          notValidatedText=""
          onChange={(evt) => setResult01(evt)}
        />
        <br />
        <p style={{ margin: '0', marginTop: '2rem' }}>HTML Output:</p>
        <div
          style={{
            marginTop: '0rem',
            padding: '1rem',
            backgroundColor: '#F9F9F9',
            borderRadius: '0.25rem',
            color: '#666',
          }}
        >
          {result01}
        </div>
      </div>
      <div style={{ flex: '1' }}>
        <RteEditor
          initialValue={result02}
          label="Editor 2"
          info="Uitleg over editor 2 wat langer om te kijken of dat ook goed gaat, want je weet maar nooit."
          placeholder="Voeg hier tekst in..."
          notValidatedText=""
          onChange={(evt) => setResult02(evt)}
        />
        <br />
        <p style={{ margin: '0', marginTop: '2rem' }}>HTML Output:</p>
        <div
          style={{
            marginTop: '0rem',
            padding: '1rem',
            backgroundColor: '#F9F9F9',
            borderRadius: '0.25rem',
            color: '#666',
          }}
        >
          {result02}
        </div>
      </div>
    </div>
  );
};
